/* =============================================================
   COMMON NEUTRALS — theme.js (Shopify OS 2.0)
   Cart AJAX + drawer + mega-menu + PDP gallery/variants + motion
   ============================================================= */
(() => {
  const RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Puntero grueso = tactil. Se usa para desactivar el smooth-scroll sintetico. */
  const COARSE = window.matchMedia('(pointer: coarse)').matches;
  /* Los listeners de resize sin throttle disparan decenas de reflows en movil
     (la barra de direcciones de iOS/Android emite resize al hacer scroll). */
  const onResize = (fn) => { let t=0; const h=()=>{ if(t) return; t=requestAnimationFrame(()=>{t=0;fn();}); };
    window.addEventListener('resize',h,{passive:true});
    window.addEventListener('orientationchange',h,{passive:true}); return h; };
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const S  = window.CNsettings || { cartDrawer:true, freeShip:250, money:'${{amount}}' };

  /* ---------- money ---------- */
  function money(cents){
    const fmt = S.money || '${{amount}}';
    const amt = (cents/100).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
    const amtNo = Math.round(cents/100).toLocaleString('en-US');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amt)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amtNo)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amt)
              .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, amtNo);
  }

  /* ---------- CART (AJAX) ---------- */
  const drawer = () => $('[data-cart-drawer]');
  const overlay = () => $('.overlay');
  function openCart(){ drawer()?.classList.add('is-open'); overlay()?.classList.add('is-open'); document.body.classList.add('no-scroll'); }
  function closeCart(){ drawer()?.classList.remove('is-open'); overlay()?.classList.remove('is-open'); document.body.classList.remove('no-scroll'); }

  async function getCart(){ return (await fetch('/cart.js')).json(); }
  async function addItem(id, qty=1){
    const r = await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:+id,quantity:qty}]})});
    if(!r.ok){ const e=await r.json(); alert(e.description||'Could not add to cart'); return; }
    await refreshCart(); if(S.cartDrawer) openCart();
  }
  async function changeItem(key, qty){
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})});
    await refreshCart();
  }
  async function refreshCart(){
    const cart = await getCart();
    $$('.cart-count, [data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:cart}));
    const sub = $('[data-cart-subtotal]'); if(sub) sub.textContent=money(cart.total_price);
    const wrap = $('[data-cart-items]');
    if(wrap) wrap.innerHTML = renderItems(cart);
    // reload cart page if present
    if($('[data-cart-page-form]')) document.dispatchEvent(new CustomEvent('cart:rerender'));
  }
  function renderItems(cart){
    const threshold = (S.freeShip||0)*100;
    let html='';
    if(threshold>0){
      const pct = Math.min(100, Math.round(cart.total_price/threshold*100));
      html += `<div class="freeship"><p class="freeship__msg">${cart.total_price>=threshold?'Free shipping unlocked':money(threshold-cart.total_price)+' away from free shipping'}</p><div class="freeship__bar"><i style="width:${pct}%"></i></div></div>`;
    }
    if(!cart.items.length){
      html += `<p class="muted" style="padding:3rem 0;font-family:var(--mono);text-transform:uppercase;font-size:.8rem">Your cart is empty.<br><br><a class="link" href="/collections/all">Shop all →</a></p>`;
      return html;
    }
    cart.items.forEach(i=>{
      html += `<div class="line-item" data-key="${i.key}">
        <div class="line-item__media">${i.image?`<img src="${i.image.replace(/(\.[a-z]+)(\?|$)/,'_200x$1$2')}" alt="">`:''}</div>
        <div><div class="line-item__name"><a href="${i.url}">${i.product_title}</a></div>
          <div class="line-item__meta">${i.variant_title||''}</div>
          <div class="qty" data-key="${i.key}"><button data-qty="-1">–</button><span>${i.quantity}</span><button data-qty="1">+</button></div></div>
        <div class="line-item__price">${money(i.final_line_price)}</div></div>`;
    });
    return html;
  }

  // event delegation for cart controls
  document.addEventListener('click', e=>{
    const open=e.target.closest('[data-cart-open]'); if(open){ e.preventDefault(); openCart(); return; }
    if(e.target.closest('[data-cart-close]')){ closeCart(); return; }
    const q=e.target.closest('.qty [data-qty]');
    if(q){ const wrap=q.closest('.qty'); const key=wrap.dataset.key; const cur=+wrap.querySelector('span').textContent; changeItem(key, cur+(+q.dataset.qty)); }
  });
  // quick-add + ATC forms
  document.addEventListener('submit', e=>{
    const qa=e.target.closest('[data-quick-add], [data-atc-form]');
    if(qa){ e.preventDefault(); const id=qa.querySelector('[name="id"]').value; addItem(id,1);
      const btn=qa.querySelector('button[type="submit"]'); if(btn){const t=btn.textContent; btn.textContent='Added'; setTimeout(()=>btn.textContent=t,1200);} }
  });

  /* ---------- MENU ---------- */
  document.addEventListener('click', e=>{
    if(e.target.closest('[data-menu-open]')){ $('[data-menu]')?.classList.add('is-open'); document.body.classList.add('no-scroll'); }
    if(e.target.closest('[data-menu-close]') || e.target.closest('.menu__link') || e.target.closest('.menu__sub a')){ $('[data-menu]')?.classList.remove('is-open'); document.body.classList.remove('no-scroll'); }
  });
  document.addEventListener('keydown', e=>{ if(e.key==='Escape'){ $('[data-menu]')?.classList.remove('is-open'); closeCart(); const lb=$('.lightbox'); if(lb) lb.classList.remove('is-open'); document.body.classList.remove('no-scroll'); } });

  /* ---------- HEADER ---------- */
  function initHeader(){
    const header=$('.header'); if(!header) return;
    const hero=$('.hero, [data-header-dark]'); let last=0;
    const onScroll=()=>{ const y=window.scrollY; const sw=hero?hero.offsetHeight-120:0; const over=hero&&y<sw;
      header.classList.toggle('on-dark',over); header.classList.toggle('is-solid',!over&&y>10);
      if(header.dataset.sticky!=='always' && y>500 && y>last) header.classList.add('hide'); else header.classList.remove('hide'); last=y; };
    window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  }

  /* ---------- ACORDEONES (footer y paginas de contenido) ----------
     Antes vivian dentro del template de producto viejo. El nuevo no usa
     acordeones (la referencia usa pestañas y las resuelve su propia
     seccion), asi que se extraen aqui para que el footer siga funcionando. */
  function initAccordions(){
    $$('.accordion__item').forEach(it=>{
      const head=$('.accordion__head',it), body=$('.accordion__body',it);
      head?.addEventListener('click',()=>{ const open=it.classList.toggle('is-open'); body.style.maxHeight=open?body.scrollHeight+'px':0; });
    });
  }

  /* ---------- gender filter (home shop-collection) ---------- */
  function initFilter(){
    const bar=$('[data-gender-filter]'), grid=$('[data-filter-grid]'); if(!bar||!grid)return;
    bar.addEventListener('click',e=>{ const c=e.target.closest('.chip'); if(!c)return;
      $$('.chip',bar).forEach(x=>x.classList.remove('is-active')); c.classList.add('is-active');
      const g=c.dataset.g; $$('.card',grid).forEach(card=>{card.style.display=(g==='all'||card.dataset.g===g)?'':'none';}); });
  }

  /* ---------- MOTION ---------- */
  function splitWords(el){ if(el.dataset.done)return; el.dataset.done=1;
    const walk=n=>{[...n.childNodes].forEach(c=>{ if(c.nodeType===3){ const f=document.createDocumentFragment();
      c.textContent.split(/(\s+)/).forEach(p=>{ if(!p.trim()){f.appendChild(document.createTextNode(p));return;} const w=document.createElement('span');w.className='word';const s=document.createElement('span');s.textContent=p;w.appendChild(s);f.appendChild(w);});
      c.replaceWith(f);} else if(c.nodeType===1){walk(c);} });}; walk(el); }
  function initMotion(){
    /* Avisa al failsafe del <head> que la animacion si arranco. */
    document.documentElement.classList.add('motion-on');
    $$('[data-split]').forEach(splitWords);
    if(RM){ $$('[data-reveal],[data-split],.stagger').forEach(e=>e.classList.add('is-in')); return; }
    let lenis; const hasGSAP=window.gsap&&window.ScrollTrigger;
    /* Lenis solo en puntero fino. En tactil sustituye el scroll nativo por uno
       sintetico y rompe el momentum de iOS/Android. */
    if(window.Lenis && !COARSE){ lenis=new Lenis({duration:1.1,easing:t=>Math.min(1,1.001-Math.pow(2,-10*t)),smoothWheel:true}); window.CN={lenis};
      if(!hasGSAP){const raf=t=>{lenis.raf(t);requestAnimationFrame(raf);};requestAnimationFrame(raf);} }
    if(hasGSAP){ gsap.registerPlugin(ScrollTrigger); document.documentElement.classList.add('gsap-on');
      if(lenis){lenis.on('scroll',ScrollTrigger.update); gsap.ticker.add(t=>lenis.raf(t*1000)); gsap.ticker.lagSmoothing(0);}
      $$('[data-split]').forEach(el=>{ gsap.from($$('.word>span',el),{yPercent:110,duration:.9,ease:'expo.out',stagger:.04,scrollTrigger:{trigger:el,start:'top 88%'}}); el.classList.add('is-in'); });
      $$('[data-reveal]').forEach(el=>gsap.to(el,{opacity:1,y:0,duration:1,ease:'expo.out',scrollTrigger:{trigger:el,start:'top 90%',onEnter:()=>el.classList.add('is-in')}}));
      $$('.stagger').forEach(el=>{gsap.to([...el.children],{opacity:1,y:0,duration:.9,ease:'expo.out',stagger:.08,scrollTrigger:{trigger:el,start:'top 86%'}});el.classList.add('is-in');});
      $$('[data-parallax] img').forEach(img=>gsap.fromTo(img,{yPercent:-7},{yPercent:7,ease:'none',scrollTrigger:{trigger:img.closest('[data-parallax]'),scrub:true,start:'top bottom',end:'bottom top'}}));
      const hi=$('.hero__inner'); if(hi) gsap.to(hi,{yPercent:-14,opacity:.5,ease:'none',scrollTrigger:{trigger:'.hero',start:'top top',end:'bottom top',scrub:true}});
      const him=$('.hero__media img'); if(him) gsap.to(him,{yPercent:10,ease:'none',scrollTrigger:{trigger:'.hero',start:'top top',end:'bottom top',scrub:true}});
    } else { const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}}),{threshold:.12}); $$('[data-reveal],[data-split],.stagger').forEach(e=>io.observe(e)); }
  }

  const boot=()=>{ initHeader(); initAccordions(); initFilter(); initMotion(); };
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',boot); } else { boot(); }
})();
